var mode = {
	DEBUG: null
};

export default mode;

